function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "current",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87 563 c-4 -3 -7 -64 -7 -134 l0 -128 -27 -3 c-14 -2 -28 -9 -31 -15 -3 -10 16 -14 70 -15 72 -2 72 -2 13 -5 -106 -6 -105 -5 -105 -74 l0 -61 31 26 c22 19 38 25 53 20 29 -9 46 -24 46 -40 0 -11 17 -14 69 -14 59 0 71 3 76 18 14 45 96 47 110 3 8 -26 20 -26 47 -1 17 16 37 20 92 21 116 2 135 17 24 18 -94 1 -98 2 -99 24 -1 12 -4 91 -8 176 -4 108 -10 156 -18 158 -10 4 -13 -37 -15 -168 -2 -127 -6 -173 -15 -177 -10 -3 -13 12 -13 55 0 44 -11 88 -46 184 l-46 126 -51 7 c-68 8 -142 8 -150 -1z m214 -118 c34 -95 34 -113 1 -89 -18 12 -21 19 -11 30 16 19 0 18 -23 -3 -23 -21 -23 -32 0 -26 27 7 44 -20 40 -64 l-3 -38 -18 33 -18 32 -84 0 -85 0 0 105 0 106 86 -3 86 -3 29 -80z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42 148 c-28 -28 -7 -78 33 -78 27 0 45 18 45 45 0 27 -18 45 -45 45 -12 0 -26 -5 -33 -12z m56 -31 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289 139 c-8 -16 -8 -28 0 -45 15 -34 67 -34 82 0 16 35 -3 66 -41 66 -20 0 -33 -7 -41 -21z m65 -15 c8 -21 -1 -34 -24 -34 -20 0 -30 17 -22 38 6 17 39 15 46 -4z"
}));

var SvgVehicle12 = function SvgVehicle12(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle12.fcd47932.svg";
export { ForwardRef as ReactComponent };